'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require('lodash.isfunction');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Check if the value is a Function
 *
 * @name isFunction
 * @param {*} param Value to be checked
 * @returns {boolean} Returns true when the `param` is a Function
 */
exports.default = _lodash2.default;
//# sourceMappingURL=isFunction.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-analysis/~/d2-utilizr/lib/isFunction.js
 ** module id = 21
 ** module chunks = 0 1
 **/